import { useState } from "react";
import { Funnel, CalendarDays, ArrowDownToLine } from "lucide-react";
import ExportSubscriptionsModal from "../../Subscriptions/components/modals/ExportSubscriptions";
import ExportModal from "../../Payments/components/modals/ExportModal";

export default function Reports() {
    const [isOpen, setIsOpen] = useState(false);
    const [openSubscriptions, setOpenSubscriptions] = useState(false);
    const [openPayments, setOpenPayments] = useState(false);

    return (
        <div className="flex items-center justify-between relative">
            <div></div>

            <div className="flex items-center gap-x-4">
                {/* Filters Button */}
                <div className="bg-card w-fit flex items-center gap-x-2 px-3 py-2 rounded-md cursor-pointer hover:scale-105">
                    <Funnel className="text-white w-4 h-4" />
                    <p className="text-white text-sm">Filters</p>
                </div>

                {/* Date Range */}
                {/* <div className="bg-card w-fit flex items-center gap-x-2 px-3 py-2 rounded-md cursor-pointer hover:scale-105">
                    <CalendarDays className="text-white w-4 h-4" />
                    <p className="text-white text-sm">July 5, 2025 - August 5, 2025</p>
                </div> */}

                {/* Download Report with Dropdown */}
                <div className="relative">
                    <div
                        onClick={() => setIsOpen(!isOpen)}
                        className="bg-card w-fit flex items-center gap-x-2 px-3 py-2 rounded-md cursor-pointer hover:scale-105"
                    >
                        <ArrowDownToLine className="text-white w-4 h-4" />
                        <p className="text-white text-sm">Download Report</p>
                    </div>

                    {isOpen && (
                        <div className="absolute right-0 mt-2 w-40 bg-card border border-gray-700 rounded-md shadow-lg z-50">
                            <button
                                className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-gray-700"
                                onClick={() => {
                                    setIsOpen(false);
                                    setOpenSubscriptions(true);
                                }}
                            >
                                Subscriptions
                            </button>
                            <button
                                className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-gray-700"
                                onClick={() => {
                                    setIsOpen(false);
                                    setOpenPayments(true);
                                }}
                            >
                                Payments
                            </button>
                        </div>
                    )}
                </div>
            </div>

            <ExportSubscriptionsModal
                isOpen={openSubscriptions}
                onClose={() => setOpenSubscriptions(false)}
            />

            <ExportModal
                isOpen={openPayments}
                onClose={() => setOpenPayments(false)}
            />
        </div>
    );
}
